import React from "react";
import styled from "styled-components";
/* import { StaticImage } from "gatsby-plugin-image"; */
import { Link } from "gatsby";

const StyledFooterFinal = styled.div`
  background-color: #34495e;
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  justify-content: space-around;
  color: #fff;
  padding: 3em;

  @media(max-width: 768px) {
    flex-direction: column;
  }

  .item {
    display: flex;
    flex-direction: column;
    &__menu {
      list-style-type: none;
      line-height: 2em;
      margin-left: auto;
      a {
        color: #FFF464;
        text-decoration: none;
      }
    }
    .menu {
        &__link {
            display: inline;
            padding-right: 0.75em;
            &:not(:last-child):after {
                content: '|';
                padding-left: 0.75em;
                color: #FFF464;
            }
        }
    }
    &--horizontal {
      flex-direction: row;
      display: flex;
      align-items: center;
      @media(max-width: 768px) {
        flex-direction: column;
        align-items: flex-start;
      }

      p {
        padding: 0 1em;
        @media(max-width: 768px) {
          padding: 0;
        }
      }
    }
  }
`;

const FooterFinal = (props) => (
  <StyledFooterFinal>
    <div className="item--horizontal">
      <a href="https://www.organismo-am.it/b/0/15394031007/a5ce4311-e8cf-4173-8307-22ac237e0037/g.html">
        <img src="https://www.organismo-am.it/b/0/1MsVUDgi69VO3Njl9YfddgK06fbJbXPQPvgkTEYGhfA_eq_.png" className="mb-3 mb-lg-0" alt="Bollino OAM" width="147" height="149" target="_blank" />
      </a>
      <div className="item">
        <p className="__title fw-bold">Prestiti Fai da Te Srl</p>
        <p>
          Sede Legale e Direzione Generale: Via Ludovisi, 35 - 00187 Roma (RM)
        </p>
        <p>© 2021 Prestiti Fai da Te Srl</p>
        <p id="disclaimer-prestiti">
        <small className="mb-2">* Per prestiti erogati attraverso la formula della cessione del quinto è possibile usufruire del tasso agevolato.</small><br />
        <small>* Le convenzioni indicate sono sottoscritte dalla società Avvera S.p.A. di cui Prestitifadate.it srl ne è mandataria</small>
        </p>
      </div>
    </div>
    <div className="item">
      <p>
        P.IVA 15394031007 Agente in Attività Finanziaria Avvera S.p.A. - Gruppo
        Bancario Credito Emiliano OAM n. A 13882
      </p>
      <ul className="item__menu">
        <li className="menu__link">
          <a href="/cookie-policy" onClick={() => window.location.href='/cookie-policy' }>Cookie</a>
        </li>
        <li className="menu__link">
          <a href="https://www.iubenda.com/privacy-policy/60549581/legal" target="_blank" rel="noreferrer">Privacy policy</a>
        </li>
        <li className="menu__link">
          <Link to="/trasparenza">Trasparenza</Link>
        </li>
        <li className="menu__link">
          <a href="https://www.tlcws.com" target="_blank" rel="noreferrer">Credits</a>
        </li>
      </ul>
    </div>
  </StyledFooterFinal>
);

export default FooterFinal;
